import { IHeroTeaser } from 'src/models/hero-teaser.model';
import { EntityActions } from '../entity.actions';

export const fromHeroTeaserActions = EntityActions.create<IHeroTeaser>('[Hero Teaser]');
